/*
 * Public API Surface of ngx-lib/attachment
 */
export * from './attachment.module';
export * from './attachment.component';
